import { AxiosResponse } from 'axios';
import { http } from 'SharedDir/backend/axios/http';

import { COMMISSION_DECISION_PARAGRAPHS_URL } from 'SharedDir/backend/endpoints/commissions';
import {
  ParagraphCommissionDecisionBare,
  ParagraphResolutionIn,
  ParagraphTextIn,
  ParagraphVoteIn,
} from 'SharedDir/declarations/commissions';

export default class CommissionParagraphsApiClass {
  protected readonly url = COMMISSION_DECISION_PARAGRAPHS_URL;

  public async vote(
    paragraphId: number,
    data: ParagraphVoteIn
  ): Promise<ParagraphCommissionDecisionBare> {
    const { data: result } = (await http({
      url: `${this.url}/${paragraphId}/vote`,
      method: 'post',
      data,
    })) as AxiosResponse<ParagraphCommissionDecisionBare>;

    return result;
  }

  public async setText(
    paragraphId: number,
    data: ParagraphTextIn
  ): Promise<ParagraphCommissionDecisionBare> {
    const { data: result } = (await http({
      url: `${this.url}/${paragraphId}/text`,
      method: 'post',
      data,
    })) as AxiosResponse<ParagraphCommissionDecisionBare>;

    return result;
  }

  public async setResolution(
    paragraphId: number,
    data: ParagraphResolutionIn
  ): Promise<ParagraphCommissionDecisionBare> {
    const { data: result } = (await http({
      url: `${this.url}/${paragraphId}/resolution`,
      method: 'post',
      data,
    })) as AxiosResponse<ParagraphCommissionDecisionBare>;

    return result;
  }
}
